import React, { useRef, useLayoutEffect, useState } from "react";
import { FixedSizeList as List } from "react-window";
import CatalogProductListItem from "./CatalogProductListItem";

const ITEM_HEIGHT = 120; // Reduzido para diminuir espaço vertical
const MIN_LIST_HEIGHT = 700; // aumenta o mínimo para 600px

export default function VirtualizedProductList({ produtos, getProductId, style }) {
  const containerRef = useRef(null);
  const [height, setHeight] = useState(MIN_LIST_HEIGHT);

  useLayoutEffect(() => {
    function updateHeight() {
      if (containerRef.current) {
        setHeight(Math.max(containerRef.current.offsetHeight, MIN_LIST_HEIGHT));
      }
    }
    updateHeight();
    window.addEventListener('resize', updateHeight);
    return () => window.removeEventListener('resize', updateHeight);
  }, []);

  return (
    <div ref={containerRef} style={{ ...style, minHeight: MIN_LIST_HEIGHT, flex: 1 }}>
      <List
        height={height}
        itemCount={produtos.length}
        itemSize={ITEM_HEIGHT}
        width={"100%"}
        style={{ minHeight: 0, maxHeight: '100%' }}
      >
        {({ index, style }) => (
          <div style={{ ...style, padding: 0 }}>
            <CatalogProductListItem key={getProductId(produtos[index])} produto={produtos[index]} />
          </div>
        )}
      </List>
    </div>
  );
}
